import { useRouteLoaderData } from 'react-router';
import { PublicPageContent } from '../PublicPath.js';
import type { PageResponse } from '../../../../generated/api/pageResponse.js';

/**
 * This path uses public page content
 */
export const InstructionsPath = () => {
  const page = useRouteLoaderData('public-path-root') as PageResponse;
  return <PublicPageContent {...page} />;
};
